import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { sortBy } from 'lodash';


import { ApiServiceServerless } from '../../../xhr_libs';
import EnergyTracerTable from '../../../components/tables';


const styles = {
  column: {
    padding: '22px 15px 15px 15px',
  },
  actionColumn: {
    padding: '16px 15px 15px 15px',
  },
};

export default function ProjectExclusions(props) {
  const {
    organization_id,
    project_id,
    buildingsLookup,
    selectedBuildings,
    utility_types,
    exclusions,
    addToList,
    removeFromList,
    showToast,
    updateAccessAnalysis,
  } = props;

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    let temp_data = [];
    if (Object.keys(buildingsLookup).length > 0) {
      selectedBuildings.forEach((building) => {
        let temp_obj = {};
        temp_obj['building'] = building;
        temp_obj['building_name'] = buildingsLookup[building]['name'];
        utility_types.forEach((utility) => {
          temp_obj[utility] = null;
          let exc = exclusions.filter(
            (exc) =>
              exc.project_id === project_id &&
              exc.building_id === parseInt(building) &&
              exc.utility_type === utility

          );
          if (exc.length !== 0) {
            temp_obj[utility] = exc[0].id
          }
        });
        temp_data.push(temp_obj);
      });
      setTableData(sortBy(temp_data, ['building_name']));
    } else {
      setTableData([]);
    }
  }, [
    project_id,
    buildingsLookup,
    selectedBuildings,
    utility_types,
    exclusions,
  ]);

  const handleUpdate = (option, project_id, organization_id, building_id, utility_type, exc_id) => {
    if (option === 'exclude') {
      addProjectExclusion(project_id, organization_id, building_id, utility_type)
    }
    else {
      deleteProjectExclusion(project_id, organization_id, exc_id)
    }
  }

  const deleteProjectExclusion = (project_id, organization_id, exc_id) => {
    ApiServiceServerless.delete(
      `/performance_projects/project_exclusion/${parseInt(project_id)}/${exc_id}`,
      { authorization_id: organization_id }
    )
      .then(() => {
        removeFromList(exc_id, 'exclusions');
      })
      .catch((err) => {
        showToast('danger', 'Error', err);
        throw err;
      });
  };

  const addProjectExclusion = (project_id, organization_id, building_id, utility_type) => {
    ApiServiceServerless.post(
      `/performance_projects/project_exclusion/${parseInt(
        project_id
      )}`,
      {
        building_id: building_id,
        utility_type: utility_type,
      },
      { authorization_id: organization_id }
    )
      .then((res) => {
        addToList(res.data, 'exclusions');
      })
      .catch((err) => {
        showToast('danger', 'Error', err);
        throw err;
      });
  };

  const buildingColumn = [
    { dataField: 'building_name', text: 'Building', style: styles.column },
  ];

  let tableColumns = [].concat(
    buildingColumn,
    utility_types.includes('electric')
      ? utilityColumn(
        'electric',
        project_id,
        organization_id,
        handleUpdate,
        updateAccessAnalysis,
      )
      : [],
    utility_types.includes('gas')
      ? utilityColumn(
        'gas',
        project_id,
        organization_id,
        handleUpdate,
        updateAccessAnalysis,
      )
      : [],
    utility_types.includes('water')
      ? utilityColumn(
        'water',
        project_id,
        organization_id,
        handleUpdate,
        updateAccessAnalysis,
      )
      : [], utility_types.includes('propane')
    ? utilityColumn(
      'propane',
      project_id,
      organization_id,
      handleUpdate,
      updateAccessAnalysis,
    )
    : []
  );

  return (
    <>
      {tableData.length > 0 && (
        <EnergyTracerTable
          data={tableData}
          columns={tableColumns}
          keyField={'building'}
        />
      )}
    </>
  );
}

function utilityColumn(
  utility,
  project_id,
  organization_id,
  handleUpdate,
  updateAccess,
) {
  return [
    {
      dataField: utility,
      text: utility.charAt(0).toUpperCase() + utility.substr(1).toLowerCase(),
      style: styles.actionColumn,
      formatter: (cell, row) => (
        <ExclusionOption
          organization_id={organization_id}
          project_id={project_id}
          row={row}
          building={row.building}
          utility={utility}
          updateAccess={updateAccess}
          handleUpdate={handleUpdate}

        />
      ),
    },
  ];
}

function ExclusionOption(props) {
  const { organization_id,
    project_id,
    row,
    building,
    utility,
    updateAccess,
    handleUpdate,
  } = props;

  return <>
    <Form.Control as='select' disabled={!updateAccess}
      onChange={(e) => handleUpdate(e.target.value, project_id, organization_id, building, utility, row[utility])}
      value={row[utility] && row[utility] !== null ? 'exclude' : 'include'} style={{ color: row[utility] && row[utility] !== null ? 'red' : 'green' }}>
      <option key={'exclude'} value={'exclude'} style={{ color: 'black' }}>Exclude</option>
      <option key={'include'} value={'include'} style={{ color: 'black' }} > Include</option>
    </Form.Control >
  </>
}